import './main.setup.ts';
import '@cascade/ui-library/style.css';
import { createRoot } from 'react-dom/client';
import { App } from './app/index.ts';

const container = document.getElementById('app');

if (!container) {
  throw new Error('The document has no #app element to mount into');
}

createRoot(container).render(<App />);
